/* eslint-disable no-restricted-globals */
function openModal(e) {
  return {
    type: 'OPEN_MODAL',
    event: e,
  };
}

function closeModal() {
  history.pushState('', document.title, window.location.pathname + window.location.search);
  return {
    type: 'CLOSE_MODAL',
  };
}

function changeDefaultTab(newDefaultTab) {
  history.pushState('', document.title, window.location.pathname + window.location.search);

  return {
    type: 'CHANGE_DEFAULT_TAB',
    newDefaultTab,
  };
}

export { closeModal, openModal, changeDefaultTab };
